__turbopack_context__.v({
  "icon": "icon-module-scss-module__7f87Eq__icon",
});
